import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { GoldDivider } from './GoldDivider';
const painPoints = ['Llevas tiempo trabajando en tu mentalidad pero los resultados no llegan', 'Tenés días buenos de frecuencia alta y caídas que borran todo', 'Leíste a Neville, Murphy, Silva pero no sabés cómo integrarlo', 'Manifestás cosas pequeñas pero lo importante no llega', 'Sentís que simplemente no sos de los que lo logran'];
export function PainSection() {
  return <SectionWrapper bgColor="bg-brand-black" data-id="element-158">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-159">
        Seamos honestos.
      </h2>

      <div className="mt-8 space-y-5 text-brand-muted text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto font-body" data-id="element-160">
        <p data-id="element-161">¿Cuántas veces sentiste esto?</p>
        <p data-id="element-162">
          Te levantás con intención. Vas a visualizar, agradecer, mantener la
          frecuencia alta. Y entonces llega el día real. El trabajo, las deudas,
          las obligaciones. Y para cuando llega la noche... ya olvidaste todo.
        </p>
        <p className="text-brand-ivory font-semibold" data-id="element-163">
          Al día siguiente, se repite.
        </p>
      </div>

      <div className="mt-12" data-id="element-164">
        <h3 className="font-heading text-lg md:text-xl text-brand-ivory text-center font-medium mb-8" data-id="element-165">
          ¿Te pasa alguno de estos?
        </h3>
        <div className="max-w-2xl mx-auto space-y-4" data-id="element-166">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3" data-id="element-167">
              <span className="text-red-400/80 text-lg mt-0.5 shrink-0" data-id="element-168">✗</span>
              <p className="text-brand-muted text-base md:text-lg font-body" data-id="element-169">
                {point}
              </p>
            </div>)}
        </div>
      </div>

      <div className="my-12" data-id="element-170">
        <GoldDivider data-id="element-171" />
      </div>

      <h3 className="font-heading text-xl md:text-2xl text-brand-gold text-center font-semibold" data-id="element-172">
        La razón exacta por la que pasa esto:
      </h3>

      <div className="mt-8 space-y-5 text-brand-muted text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto font-body" data-id="element-173">
        <p data-id="element-174">La manifestación no falla por falta de fe.</p>
        <p className="text-brand-ivory font-semibold text-lg md:text-xl" data-id="element-175">
          Falla porque opera en fragmentos.
        </p>
        <p data-id="element-176">
          Tu mente consciente quiere el cambio. Tu subconsciente sigue el
          programa viejo. Tu cuerpo vibra en frecuencia del pasado. Y mientras
          dormís, nadie le da instrucciones a tu cerebro.
        </p>
        <p className="text-brand-ivory font-semibold text-lg md:text-xl" data-id="element-177">
          Resultado: 8 horas de sueño trabajando en tu contra.
        </p>
        <p data-id="element-178">Eso es lo que ha estado pasando. Y nadie te lo explicó.</p>
      </div>
    </SectionWrapper>;
}